function initSocial() {
  const slider = document.querySelector('.social__slider');

  if (!slider) {
    return;
  }

  const swiper = new Swiper(slider, {
    slidesPerView: 4,
    spaceBetween: 20,

    breakpoints: {
      0: {
        slidesPerView: 2,
        grid: {
          rows: 2,
          fill: 'row',
        },
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 10,
        grid: null
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    },

    navigation: {
      nextEl: '.social__slider .swiper-navigation__btn--next',
    },
  });
}

export { initSocial };